import React from "react";

import InjectedTrainingCheckoutForm from "./TrainingCheckoutForm";

class TrainingMyStoreCheckout extends React.Component {
  render() {
    return (
      <div>
        <InjectedTrainingCheckoutForm />
      </div>
    );
  }
}

export default TrainingMyStoreCheckout;